<template>
  <div class="invoiceManage-bd tb" v-if="tableVisible">
    <custom-tab v-model="tab" :list="tabList" @change="onChangeTab" style="margin-left: -16px; width: calc(100% + 32px)"></custom-tab>
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 已申请 1-->
        <el-form-item style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click.native="exportTable()"><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.keyword" :placeholder="$t('fms_invoiceReceive.fa_piao_bian_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <!-- 更多搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link" ref="containerBtn"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <!-- <el-form-item :label="$t('p_invoiceReceive_nsrsbh')">
          <el-input v-model="formSearch.buyerNumber"></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('fms_invoiceReceive.gou_mai_fang')">
          <el-input v-model="formSearch.buyerName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_invoiceReceive.fa_piao_lei_xing')">
          <invoice-type-select
              v-model="formSearch.invoiceTypeValue"
              ref="invoiceTypeSelect"
              @change="updateTypeAndClassByValue(formSearch, $event)"
              :clearable="true"
              :defaultValue="false"
          ></invoice-type-select>
        </el-form-item>
      </el-form>
    </switch-container>
    <!-- 已申请 -->
    <custom-table
      v-if="tab == '1'"
      key="1"
      index
      height="100%"
      :loading="totalRows === null"
      :data="tableList"
      tableCode="receiptSubmit"
      @sort="sortChange"
      @filter="filterChange"
      @column="getColumn"
      :slots="['invoiceAmount', 'totalTerm', 'invoiceType', 'action']"
    >
      <template slot="invoiceType" slot-scope="scope">{{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) || '-' }}</template>
      <template slot="invoiceAmount" slot-scope="scope">
        <template v-if="scope.row.isRedInvoice">
          <span>{{ scope.row.redInvoiceAmount || '-' }}</span>
        </template>
        <template v-else>
          <span>{{ scope.row.invoiceAmount || '-' }}</span>
        </template>
      </template>
      <template slot="totalTerm" slot-scope="scope">
        <div v-if="scope.row.termNum && scope.row.totalTerm">{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
      </template>
      <template slot="action" slot-scope="scope">
        <span></span>
        <el-button v-if="funcView.invoice_receive_del" type="text" size="mini" @click="deleteWaitInvoice(scope.row)">{{ funcView.invoice_receive_del }}</el-button>
      </template>
    </custom-table>
    <!-- 已收票 -->
    <custom-table
      key="2"
      v-if="tab === '10'"
      height="100%"
      index
      :loading="totalRows === null"
      :data="tableList"
      tableCode="receiptInvoiced"
      @sort="sortChange"
      @filter="filterChange"
      @column="setColumn"
      :slots="['invoiceNum', 'invoiceAmount', 'invoiceType', 'action']"
    >
      <template slot="invoiceType" slot-scope="scope">{{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) || '-' }}</template>
      <template slot="invoiceNum" slot-scope="scope">
        <template v-if="scope.row.isRedInvoice && funcView.invoice_receive_detail">
          <span class="cell-link" @click="onInvoiceDetails(scope.row.invoiceId, scope.row.isRedInvoice)">{{ scope.row.invoiceNum || '-' }}</span>
          /
          <span class="cell-link" @click="onInvoiceDetails(scope.row.oldInvoiceId)">{{ scope.row.oldInvoiceNum || '-' }}</span>
        </template>
        <template v-else>
          <span class="cell-link" @click="onInvoiceDetails(scope.row.invoiceId, scope.row.isRedInvoice)">{{ scope.row.invoiceNum || '-' }}</span>
        </template>
      </template>
      <template slot="invoiceAmount" slot-scope="scope">
        <template v-if="scope.row.isRedInvoice">
          <span>{{ scope.row.redInvoiceAmount || '-' }}</span>
        </template>
        <template v-else>
          <span>{{ scope.row.invoiceAmount || '-' }}</span>
        </template>
      </template>
      <template slot="action" slot-scope="scope">
        <span></span>
        <el-button v-if="funcView.invoice_receive_check_detail && scope.row.invoiceUrl" type="text" size="mini" @click="viewInvoiceUrl(scope.row)">{{ funcView.invoice_receive_check_detail }}</el-button>
        <el-button v-if="funcView.invoice_receive_email && isShowEmail(scope.row)" type="text" size="mini" @click="showEmail(scope.row)">{{ funcView.invoice_receive_email }}</el-button>
      </template>
    </custom-table>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 发票详情 -->
    <invoice-details-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"></invoice-details-dialog>
    <!-- 发送邮件 -->
    <send-email-dialog v-if="emailVisible" :model="emailModel" @close="emailVisible = false" @success="getTableList"></send-email-dialog>
  </div>
</template>
<script>
import qs from 'qs';
import apis from '@/utils/apis';
import invoiceDetailsDialog from '@/pages/fms/components/invoice_details_dialog.vue';
import sendEmailDialog from '@/pages/fms/components/send_email_dialog.vue';
import invoiceTypeMixins from '@/mixins/invoice_type_mixins.js';
import invoiceTypeSelect from '@/components/invoiceTypeSelect.vue';

export default {
  name: 'invoiceReceive',
  mixins: [invoiceTypeMixins],
  components: { invoiceDetailsDialog, sendEmailDialog, invoiceTypeSelect },
  data() {
    return {
      tableColumn: [],
      tab: '1',
      formSearch: {
        invoiceTypeValue: '',
        invoiceType: '',
        invoiceClass: '',
        keyword: '',
        buyerNumber: '',
        buyerName: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1
      },
      tableSelect: [],
      tableList: [],
      totalRows: null,
      dialogVisible1: false,
      dialogModel1: {},
      link: null,
      emailVisible: false,
      emailModel: {},
    };
  },
  computed: {
    tableVisible() {
      return this.funcView.invoice_receive_has_apply_list || this.funcView.invoice_receive_has_receive_list;
    },
    tabList() {
      const ret = [];
      if (this.funcView.invoice_receive_has_apply_list) {
        ret.push({
          name: this.$t('fms_invoiceReceive.yi_shen_qing'),
          value: '1'
        });
      }
      if (this.funcView.invoice_receive_has_receive_list) {
        ret.push({
          name: this.$t('fms_invoiceReceive.yi_wan_cheng'),
          value: '10'
        });
      }

      return ret;
    }
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

  },
  methods: {
    viewInvoiceUrl(row) {
      window.open(row.invoiceUrl);
    },
    // show Email 判断
    isShowEmail(row) {
      // 只有电子类型才能显示
      const invoiceClassMap = this.dicMap.invoice_class;
      return invoiceClassMap && (`${invoiceClassMap.electronic}` === `${row.invoiceClass}`);
    },
    showEmail(row) {
      this.emailModel = {
        title: this.$t('fms_invoiceReceive.fa_song_you_jian'),
        data: row
      };
      this.emailVisible = true;
    },
    getColumn(table) {
      this.tableColumn = table.tableColumn;
      this.setColumn(table);
    },

    onInvoiceDetails: function (invoiceId, isRedInvoice) {
      // isRedInvoice true是冲红
      // isRedInvoice false是蓝票
      this.dialogModel1.type = isRedInvoice;
      this.dialogModel1.title = this.$t('fms_invoiceReceive.fa_piao_xiang_qing');
      this.dialogModel1.invoiceId = invoiceId;
      this.dialogVisible1 = true;
    },
    // 切换状态
    onChangeTab: function () {
      this.$refs.container.close();
      this.$refs.containerBtn.open = false;
      this.tableSelect = [];
      this.tableList = [];
      this.totalRows = null;
      this.clearFilter();
    },
    // 获取表格数据
    getTableList: function () {
      if (this.tab === '1') {
        this.$getJSON(apis.invoicePage4BuyerWait2Invoice, this.formSearch).then((res) => {
          if (this.tab === '1') {
            this.tableList = res.data.records;
            this.totalRows = res.data.total;
          }
        });
      } else if (this.tab === '10') {
        this.$getJSON(apis.invoicePage4Buyer, { ...this.formSearch, invoiceState: 10 }).then((res) => {
          if (this.tab === '10') {
            this.tableList = res.data.records;
            this.totalRows = res.data.total;
          }
        });
      }
    },
    // 导出表格数据
    exportTable() {
      const param = {};
      Object.keys(this.formSearch).forEach((key) => {
        const val = this.formSearch[key];
        if (val) {
          param[key] = val;
        }
      });
      delete param.pageSize;
      delete param.pageNum;
      if (this.tab === '10') {
        param.invoiceState = 10;
      }
      const pathParms = qs.stringify(param, { arrayFormat: 'repeat' });
      const headerList = this.tableColumn
        .filter(t => t.isExport)
        .map(i => ({ columnCode: i.columnCode, columnName: i.columnName, width: i.width, isFormat: i.isFormat, formatRule: i.formatRule, dicGroup: i.dicGroup }));
      this.headerListAddInvoiceClass(headerList);
      const reqData = {
        exportName: this.tab === '1' ? this.$t('fms_invoiceReceive.spglysq') : this.$t('fms_invoiceReceive.spglywc'),
        headerList: headerList,
      };
      this.exporting = true;
      this.$exportFliePost(`${this.tab === '1' ? apis.invoicePage4BuyerWait2InvoiceExport : apis.invoicePage4BuyerExport}?${pathParms}`, reqData)
        .then(() => {
          this.exporting = false;
        })
        .catch(() => {
          this.exporting = false;
        });

    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清空
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    // 删除待申请开票
    deleteWaitInvoice: function (row) {
      const data = row ? [row.invoiceBillWaitId] : this.tableSelect.map(t => t.invoiceBillWaitId);
      this.$showConfirm(this.$t('fms_invoiceReceive.nqdyscgdsqfpm'))
        .then(() => {
          this.$postJSON(apis.invoiceDelete, data).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss"></style>
